/**
 * Phone Number Formatting Utilities
 * Formats Syrian phone numbers for display
 * API Format: +963931443885
 * Display Format: +963 931-443-885
 */

/**
 * Format phone number from API format to display format
 * @param {string} phoneNumber - Phone number in API format (+963931443885)
 * @returns {string} - Formatted phone number (+963 931-443-885) or original if invalid
 */
export const formatPhoneNumberForDisplay = (phoneNumber) => {
  if (!phoneNumber) return "";
  
  // Handle string values
  let phoneStr = typeof phoneNumber === 'string' ? phoneNumber : String(phoneNumber);
  
  // Remove country code
  let cleaned = phoneStr.replace(/^\+?963/, "");
  
  // Remove leading 0 if present
  if (cleaned.startsWith("0")) {
    cleaned = cleaned.substring(1);
  }
  
  // Only keep digits, max 9
  cleaned = cleaned.replace(/\D/g, "").substring(0, 9);
  
  // If we don't have 9 digits, return original or empty
  if (cleaned.length !== 9) {
    return phoneStr; // Return original if not valid format
  }
  
  // Format: XXX-XXX-XXX
  const formatted = `${cleaned.substring(0, 3)}-${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
  
  // Return with country code prefix
  return `+963 ${formatted}`;
};

/**
 * Format phone number component (just the number part without country code)
 * @param {string} phoneNumber - Phone number in API format
 * @returns {string} - Formatted number (931-443-885) or original if invalid
 */
export const formatPhoneNumberOnly = (phoneNumber) => {
  if (!phoneNumber) return "";
  
  let phoneStr = typeof phoneNumber === 'string' ? phoneNumber : String(phoneNumber);
  let cleaned = phoneStr.replace(/^\+?963/, "");
  
  if (cleaned.startsWith("0")) {
    cleaned = cleaned.substring(1);
  }
  
  cleaned = cleaned.replace(/\D/g, "").substring(0, 9);
  
  if (cleaned.length !== 9) {
    return phoneStr;
  }
  
  return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
};
